import React from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import Skeleton from 'Common/Components/Skeleton';
import Checkbox from 'Common/Components/Checkbox/index';
import { updateCredential } from 'store/Credentials/actions';

const OwnedCell = ({ rowInfo, showSkeleton, field }) => {
  const value = get(rowInfo, `original.value.${field}`, '');
  const credential = get(rowInfo, 'original', {});
  const dispatch = useDispatch();

  const handleClick = (e) => {
    e.stopPropagation();
    dispatch(updateCredential(credential, 'owned', !value));
  };

  if (showSkeleton) return <Skeleton />;
  return (
    <Checkbox state={ value } onChange={ handleClick } />
  );
};

OwnedCell.propTypes = {
  rowInfo: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  showSkeleton: PropTypes.bool
};

OwnedCell.defaultProps = {
  field: '',
  showSkeleton: false
};

export default OwnedCell;
